import { type PickerComponents } from "@mui/x-date-pickers/themeAugmentation";

export const dateTimePicker: PickerComponents["MuiDateTimePicker"] = {
  defaultProps: {
    slotProps: {
      textField: {
        variant: "outlined",
        size: "small",
        InputLabelProps: { shrink: true },
        InputProps: { notched: true },
      },
    },
  },
};
